const filterEmpty = (obj) => {
    const result = {};

    for (const [key, value] of Object.entries(obj)) {
        if (Array.isArray(value)) {
            let cleaned = [];

            if (key === "career") {
                cleaned = value.filter(
                    (item) => item.title?.trim() || item.description?.trim()
                );
            } else if (key === "notableWork") {
                cleaned = value.filter((item) => item.title?.trim());
            } else if (key === "sns") {
                cleaned = value.filter((item) => item.url?.trim());
            } else {
                cleaned = value;
            }

            if (cleaned.length > 0) {
                result[key] = cleaned;
            }
        } else if (value !== undefined && value !== null && value !== "") {
            result[key] = value;
        }
    }

    return result;
};

const prepIdentificationNumber = (firstHalf, secondHalf) => {
    const first = firstHalf?.trim();
    const second = secondHalf?.trim();

    let identificationNumber = null;
    if (first?.length > 0 && second?.length > 0) {
        return `${first}-${second}`;
    }

    return identificationNumber;
};

const prepBirthDate = (year, month, day) => {
    if (year && month != null && day != null) {
        const pad = (n) => String(n).padStart(2, "0");
        return `${year}-${pad(month)}-${pad(day)}`;
    }
    return null;
};

export const getCreatePayload = (authorityType, authorUserData, userData) => {
    const isAuthor = authorityType === "AUTHOR";
    const data = isAuthor ? authorUserData : userData;

    const {
        email, password, name, gender, birthYear, birthMonth, birthDay, phoneNumber, profileImageUrl
    } = data;

    const birthDate = prepBirthDate(birthYear, birthMonth, birthDay);

    const basePayload = {
        authMethod: "LOCAL",
        authority_type: authorityType,
        email,
        password,
        name,
        gender,
        birthDate,
        phoneNumber,
        profileImageUrl,
    };

    if (!isAuthor) return filterEmpty(basePayload);

    // Author CREATE payload creation
    const {
        penName, idFirstHalf, idSecondHalf, address, deliveryAddress,
        useSameAddress, bankName, bankAccountNumber, education, degree,
        major, organization, rating, genre, subgenre, career, notableWork, sns,
    } = authorUserData;

    const identificationNumber = prepIdentificationNumber(idFirstHalf, idSecondHalf);

    return filterEmpty({
        ...basePayload,
        authorDetails: filterEmpty({
            penName,
            identificationNumber,
            address,
            deliveryAddress,
            useSameAddress,
            bankName,
            bankAccountNumber,
            education,
            degree,
            major,
            organization,
            rating,
            genre,
            subgenre,
            career,
            notableWork,
            sns,
        }),
    });
};

export const getUpdatePayload = (authorityType, authorUserData, userData) => {
    const isAuthor = authorityType === "AUTHOR";
    const data = isAuthor ? authorUserData : userData;

    const {
        email, name, gender, birthYear, birthMonth, birthDay, phoneNumber, profileImageUrl
    } = data;

    const birthDate = prepBirthDate(birthYear, birthMonth, birthDay);

    // Commented fields should no be updated unless login security can be assured.
    const basePayload = {
        authority_type: authorityType,
        // email,
        name,
        gender,
        birthDate,
        // phoneNumber,
        profileImageUrl,
    };

    if (!isAuthor) return filterEmpty(basePayload);

    // Author UPDATE payload creation
    const {
        penName, idFirstHalf, idSecondHalf, address, deliveryAddress,
        useSameAddress, bankName, bankAccountNumber, education, degree,
        major, organization, rating, genre, subgenre, career, notableWork, sns,
    } = authorUserData;

    const identificationNumber = prepIdentificationNumber(idFirstHalf, idSecondHalf);

    return filterEmpty({
        ...basePayload,
        authorDetails: filterEmpty({
            penName,
            identificationNumber,
            address,
            deliveryAddress,
            useSameAddress,
            bankName,
            bankAccountNumber,
            education,
            degree,
            major,
            organization,
            rating,
            genre,
            subgenre,
            career,
            notableWork,
            sns,
        }),
    });
};